<template>
  <nav id="navbarBlur" :key="key" :class="`${!isNavFixed
    ? 'navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none'
    : `navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none position-sticky ${darkMode ? 'bg-default' : 'bg-white'
    } left-auto top-2 z-index-sticky`
    } ${isRTL ? 'top-0 position-sticky z-index-sticky' : ''}`" v-bind="$attrs" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <button
        class="d-xl-none me-3 navbar-menu-toggle"
        type="button"
        aria-label="Open navigation"
        @click="toggleSidenav"
      >
        <i class="fas fa-bars" aria-hidden="true"></i>
        <span class="navbar-menu-label">Menu</span>
      </button>
      <breadcrumbs :current-page="currentRouteName" :current-directory="currentDirectory" />

      <!-- Back Button -->
      <div class="back-button">
        <a href="#" class="p-0 nav-link text-body" @click.prevent="goBack">
          <i class="fas fa-arrow-left"></i>
        </a>
      </div>
      <div class="refresh-button">
        <a href="#" class="p-0 nav-link text-body" @click.prevent="refreshPage">
          <i class="fas fa-sync-alt"></i>
        </a>
      </div>
      <!-- Play Button -->
<!-- Play Button -->
<!--div class="play-button tooltip-container">
  <a href="#" class="p-0 nav-link text-body" @click.prevent="playAction">
    <i class="fas fa-play-circle"></i>
  </a>
  <span class="tooltip-text">Play Tutorial</span>
</div-->






      <div v-if="showSearchHeader" class="header-title" style="position: relative; margin-left: 100px; display: flex; align-items: center; flex-direction: column; gap: 10px;">
  <!-- Search Input -->
  <input 
    v-model="searchQuery" 
    type="text" 
    placeholder="Search by name..." 
    class="form-control" 
    style="width: 150%; max-width: 600px; padding: 10px; border-radius: 5px; border: 1px solid #ccc; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);"
    @input="filterResults"
  />

  <!-- Filtered Dropdown -->
  <ul 
    v-if="filteredResults.length > 0" 
    class="dropdown-menu show" 
    style="position: absolute; margin-left: -48px; top: calc(100% + 5px); left: 0; width: 150%; max-width: none; z-index: 1050; border-radius: 0.5rem; box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);"
  >
    <li 
      v-for="result in filteredResults" 
      :key="result.id" 
      class="dropdown-item border-radius-md" 
      style="cursor: pointer;" 
      @click="selectResult(result)"
    >
      {{ result.client_name }}
    </li>
  </ul>
</div>



      <div v-if="showHeaderTitle" class="header-title" style="display: flex; align-items: baseline;">
        <h3 style="margin: 20;">{{ headerTitle }}</h3>
        <h3 v-if="showingDaysToClose"
          :style="{ color: daysToClose < 7 ? 'red' : 'white', marginLeft: '28px', lineHeight: '1.2' }">
          {{ daysToClose }}
          <span style="color: white; font-size: .7em; margin-left: 3px;">Days to close</span>
        </h3>
        
      </div>


      <button
    id="invisibleTutButton"
    style="
      position: absolute;
      width: 1px;
      height: 1px;
      opacity: 0;
      pointer-events: auto;
    "
    @click="playAction">
  </button>

      <div id="navbar" class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="isRTL ? 'px-0' : 'me-sm-4'">
        <div class="pe-md-3 d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
          <svg v-if="hasTutorialForCurrentRoute" class="cursor-pointer" width="153" height="40" viewBox="0 0 153 40" fill="none" xmlns="http://www.w3.org/2000/svg" @click.prevent="playAction">
<rect x="0.695122" y="0.695122" width="151.61" height="38.6098" rx="6.30488" fill="#2333AD" stroke="white" stroke-width="1.39024"/>
<path d="M47.8788 25.1221V15.0112H51.8678C52.6347 15.0112 53.288 15.1577 53.8278 15.4506C54.3676 15.7402 54.779 16.1434 55.062 16.6601C55.3484 17.1736 55.4915 17.766 55.4915 18.4374C55.4915 19.1089 55.3467 19.7013 55.0571 20.2147C54.7675 20.7282 54.3478 21.1281 53.7982 21.4144C53.2518 21.7008 52.5903 21.8439 51.8135 21.8439H49.271V20.1308H51.4679C51.8793 20.1308 52.2184 20.0601 52.4849 19.9185C52.7548 19.7737 52.9556 19.5746 53.0873 19.3212C53.2222 19.0644 53.2897 18.7699 53.2897 18.4374C53.2897 18.1017 53.2222 17.8088 53.0873 17.5587C52.9556 17.3052 52.7548 17.1094 52.4849 16.9712C52.2151 16.8296 51.8728 16.7589 51.4581 16.7589H50.0165V25.1221H47.8788ZM58.9437 15.0112V25.1221H56.8406V15.0112H58.9437ZM62.7908 25.2652C62.307 25.2652 61.8758 25.1813 61.4973 25.0135C61.1188 24.8423 60.8193 24.5905 60.5988 24.2581C60.3816 23.9224 60.273 23.5044 60.273 23.0041C60.273 22.5828 60.3503 22.229 60.505 21.9427C60.6597 21.6563 60.8703 21.4259 61.1369 21.2515C61.4035 21.0771 61.7063 20.9454 62.0453 20.8565C62.3876 20.7677 62.7464 20.7051 63.1216 20.6689C63.5626 20.6229 63.9181 20.5801 64.188 20.5406C64.4579 20.4978 64.6537 20.4353 64.7755 20.353C64.8973 20.2707 64.9581 20.1489 64.9581 19.9876V19.958C64.9581 19.6454 64.8594 19.4034 64.6619 19.2323C64.4677 19.0611 64.1913 18.9756 63.8325 18.9756C63.454 18.9756 63.1529 19.0595 62.9291 19.2274C62.7052 19.3919 62.5571 19.5993 62.4847 19.8494L60.5396 19.6914C60.6383 19.2306 60.8325 18.8324 61.1221 18.4967C61.4118 18.1577 61.7853 17.8977 62.2428 17.7167C62.7036 17.5323 63.2368 17.4402 63.8424 17.4402C64.2637 17.4402 64.6669 17.4896 65.0519 17.5883C65.4403 17.687 65.7843 17.8401 66.0838 18.0474C66.3866 18.2548 66.6252 18.5214 66.7996 18.8472C66.9741 19.1698 67.0613 19.5565 67.0613 20.0074V25.1221H65.0668V24.0705H65.0075C64.8857 24.3075 64.7228 24.5165 64.5188 24.6975C64.3147 24.8752 64.0695 25.0151 63.7831 25.1171C63.4968 25.2159 63.166 25.2652 62.7908 25.2652ZM63.3931 23.8138C63.7025 23.8138 63.9757 23.7529 64.2127 23.6311C64.4496 23.506 64.6356 23.3382 64.7705 23.1275C64.9055 22.9169 64.973 22.6783 64.973 22.4117V21.607C64.9071 21.6498 64.8166 21.6892 64.7014 21.7255C64.5895 21.7584 64.4628 21.7896 64.3213 21.8193C64.1797 21.8456 64.0382 21.8703 63.8967 21.8933C63.7552 21.9131 63.6268 21.9312 63.5116 21.9476C63.2648 21.9838 63.0492 22.0414 62.8649 22.1204C62.6806 22.1994 62.5374 22.3064 62.4354 22.4413C62.3333 22.573 62.2823 22.7375 62.2823 22.935C62.2823 23.2213 62.386 23.4402 62.5933 23.5916C62.804 23.7397 63.0706 23.8138 63.3931 23.8138ZM69.7198 27.9658C69.4532 27.9658 69.2031 27.9444 68.9694 27.9016C68.739 27.8621 68.5481 27.8111 68.3967 27.7485L68.8707 26.1786C69.1175 26.2543 69.3397 26.2954 69.5372 26.302C69.7379 26.3086 69.9107 26.2625 70.0555 26.1638C70.2036 26.065 70.3238 25.8972 70.4159 25.6602L70.5394 25.3393L67.8191 17.5389H70.0309L71.6008 23.1078H71.6798L73.2646 17.5389H75.4911L72.5438 25.9416C72.4022 26.3497 72.2097 26.7052 71.9661 27.008C71.7259 27.3141 71.4214 27.5494 71.0528 27.714C70.6842 27.8818 70.2398 27.9658 69.7198 27.9658ZM79.4394 16.7737V15.0112H87.7434V16.7737H84.6479V25.1221H82.5349V16.7737H79.4394ZM92.9025 21.8933V17.5389H95.0056V25.1221H92.9864V23.7447H92.9074C92.7363 24.189 92.4516 24.5461 92.0533 24.816C91.6584 25.0859 91.1762 25.2208 90.6068 25.2208C90.0999 25.2208 89.654 25.1056 89.2689 24.8752C88.8838 24.6448 88.5827 24.3173 88.3654 23.8928C88.1515 23.4682 88.0429 22.9597 88.0396 22.3673V17.5389H90.1427V21.992C90.146 22.4397 90.2662 22.7935 90.5031 23.0535C90.7401 23.3135 91.0577 23.4435 91.456 23.4435C91.7094 23.4435 91.9464 23.3859 92.1669 23.2707C92.3874 23.1522 92.5651 22.9778 92.7001 22.7474C92.8383 22.517 92.9058 22.2323 92.9025 21.8933ZM100.721 17.5389V19.1187H96.1547V17.5389H100.721ZM97.1915 15.7221H99.2946V22.7918C99.2946 22.986 99.3242 23.1374 99.3835 23.246C99.4427 23.3514 99.525 23.4254 99.6303 23.4682C99.7389 23.511 99.864 23.5324 100.006 23.5324C100.104 23.5324 100.203 23.5241 100.302 23.5077C100.4 23.4879 100.476 23.4731 100.529 23.4633L100.86 25.0283C100.754 25.0612 100.606 25.099 100.415 25.1418C100.224 25.1879 99.9924 25.2159 99.7192 25.2257C99.2123 25.2455 98.768 25.178 98.3862 25.0233C98.0077 24.8686 97.7131 24.6284 97.5025 24.3025C97.2918 23.9767 97.1882 23.5653 97.1915 23.0683V15.7221ZM105.436 25.2702C104.669 25.2702 104.006 25.1073 103.447 24.7814C102.89 24.4523 102.461 23.9948 102.158 23.409C101.855 22.8198 101.704 22.1369 101.704 21.3601C101.704 20.5768 101.855 19.8922 102.158 19.3063C102.461 18.7172 102.89 18.2597 103.447 17.9339C104.006 17.6047 104.669 17.4402 105.436 17.4402C106.203 17.4402 106.865 17.6047 107.421 17.9339C107.98 18.2597 108.411 18.7172 108.714 19.3063C109.017 19.8922 109.168 20.5768 109.168 21.3601C109.168 22.1369 109.017 22.8198 108.714 23.409C108.411 23.9948 107.98 24.4523 107.421 24.7814C106.865 25.1073 106.203 25.2702 105.436 25.2702ZM105.446 23.641C105.795 23.641 106.086 23.5422 106.32 23.3448C106.554 23.144 106.73 22.8708 106.848 22.5252C106.97 22.1797 107.031 21.7863 107.031 21.3453C107.031 20.9043 106.97 20.511 106.848 20.1654C106.73 19.8198 106.554 19.5466 106.32 19.3458C106.086 19.1451 105.795 19.0447 105.446 19.0447C105.094 19.0447 104.798 19.1451 104.557 19.3458C104.32 19.5466 104.141 19.8198 104.019 20.1654C103.901 20.511 103.842 20.9043 103.842 21.3453C103.842 21.7863 103.901 22.1797 104.019 22.5252C104.141 22.8708 104.32 23.144 104.557 23.3448C104.798 23.5422 105.094 23.641 105.446 23.641ZM110.536 25.1221V17.5389H112.575V18.862H112.654C112.792 18.3914 113.024 18.0359 113.35 17.7956C113.676 17.5521 114.051 17.4303 114.476 17.4303C114.581 17.4303 114.695 17.4369 114.816 17.4501C114.938 17.4632 115.045 17.4813 115.137 17.5044V19.3705C115.039 19.3409 114.902 19.3146 114.727 19.2915C114.553 19.2685 114.393 19.257 114.249 19.257C113.939 19.257 113.663 19.3245 113.419 19.4594C113.179 19.591 112.988 19.7754 112.847 20.0123C112.708 20.2493 112.639 20.5225 112.639 20.8319V25.1221H110.536ZM116.225 25.1221V17.5389H118.328V25.1221H116.225ZM117.281 16.5614C116.968 16.5614 116.7 16.4577 116.476 16.2504C116.256 16.0397 116.146 15.788 116.146 15.495C116.146 15.2054 116.256 14.9569 116.476 14.7495C116.7 14.5389 116.968 14.4336 117.281 14.4336C117.594 14.4336 117.86 14.5389 118.081 14.7495C118.305 14.9569 118.417 15.2054 118.417 15.495C118.417 15.788 118.305 16.0397 118.081 16.2504C117.86 16.4577 117.594 16.5614 117.281 16.5614ZM122.175 25.2652C121.691 25.2652 121.26 25.1813 120.881 25.0135C120.503 24.8423 120.203 24.5905 119.983 24.2581C119.766 23.9224 119.657 23.5044 119.657 23.0041C119.657 22.5828 119.734 22.229 119.889 21.9427C120.044 21.6563 120.254 21.4259 120.521 21.2515C120.788 21.0771 121.09 20.9454 121.429 20.8565C121.772 20.7677 122.13 20.7051 122.506 20.6689C122.947 20.6229 123.302 20.5801 123.572 20.5406C123.842 20.4978 124.038 20.4353 124.16 20.353C124.281 20.2707 124.342 20.1489 124.342 19.9876V19.958C124.342 19.6454 124.243 19.4034 124.046 19.2323C123.852 19.0611 123.575 18.9756 123.217 18.9756C122.838 18.9756 122.537 19.0595 122.313 19.2274C122.089 19.3919 121.941 19.5993 121.869 19.8494L119.924 19.6914C120.022 19.2306 120.217 18.8324 120.506 18.4967C120.796 18.1577 121.169 17.8977 121.627 17.7167C122.088 17.5323 122.621 17.4402 123.226 17.4402C123.648 17.4402 124.051 17.4896 124.436 17.5883C124.824 17.687 125.168 17.8401 125.468 18.0474C125.771 18.2548 126.009 18.5214 126.184 18.8472C126.358 19.1698 126.445 19.5565 126.445 20.0074V25.1221H124.451V24.0705H124.392C124.27 24.3075 124.107 24.5165 123.903 24.6975C123.699 24.8752 123.454 25.0151 123.167 25.1171C122.881 25.2159 122.55 25.2652 122.175 25.2652ZM122.777 23.8138C123.087 23.8138 123.36 23.7529 123.597 23.6311C123.834 23.506 124.02 23.3382 124.155 23.1275C124.29 22.9169 124.357 22.6783 124.357 22.4117V21.607C124.291 21.6498 124.201 21.6892 124.085 21.7255C123.974 21.7584 123.847 21.7896 123.705 21.8193C123.564 21.8456 123.422 21.8703 123.281 21.8933C123.139 21.9131 123.011 21.9312 122.896 21.9476C122.649 21.9838 122.433 22.0414 122.249 22.1204C122.065 22.1994 121.921 22.3064 121.819 22.4413C121.717 22.573 121.666 22.7375 121.666 22.935C121.666 23.2213 121.77 23.4402 121.977 23.5916C122.188 23.7397 122.455 23.8138 122.777 23.8138ZM130.18 15.0112V25.1221H128.077V15.0112H130.18Z" fill="white"/>
<path d="M38.9812 20.4249C38.9812 17.7865 37.9109 15.3957 36.182 13.6678C34.4532 11.9398 32.0633 10.8687 29.4249 10.8687C26.7865 10.8687 24.3957 11.939 22.6678 13.6678C20.9398 15.3966 19.8687 17.7865 19.8687 20.4249C19.8687 23.0633 20.939 25.4541 22.6678 27.182C24.3966 28.91 26.7865 29.9812 29.4249 29.9812C32.0633 29.9812 34.4541 28.9109 36.182 27.182C37.91 25.4532 38.9812 23.0633 38.9812 20.4249ZM37.2437 20.4249C37.2437 22.5846 36.3697 24.5376 34.9536 25.9536C33.5376 27.3697 31.5846 28.2437 29.4249 28.2437C27.2652 28.2437 25.3122 27.3697 23.8962 25.9536C22.4801 24.5376 21.6062 22.5846 21.6062 20.4249C21.6062 18.2652 22.4801 16.3122 23.8962 14.8962C25.3122 13.4801 27.2652 12.6062 29.4249 12.6062C31.5846 12.6062 33.5376 13.4801 34.9536 14.8962C36.3697 16.3122 37.2437 18.2652 37.2437 20.4249ZM28.1696 16.2271C28.034 16.1359 27.8672 16.0812 27.6874 16.0812C27.2079 16.0812 26.8187 16.4704 26.8187 16.9499V23.8999C26.8178 24.0632 26.8647 24.2326 26.9646 24.3821C27.2304 24.7817 27.7699 24.8894 28.1696 24.6227L33.3821 21.1477C33.4715 21.0886 33.5558 21.007 33.6227 20.9071C33.8885 20.5074 33.7808 19.9688 33.3821 19.7021L28.1696 16.2271ZM28.5562 18.5736L31.3335 20.4249L28.5562 22.2762V18.5736Z" fill="white"/>
</svg>
<!-- Compact Mobile QR Login Button -->
<div class="ms-3 d-flex align-items-center cursor-pointer" title="Mobile QR Login" @click.prevent="openQrModal">
  <div
    class="d-flex align-items-center justify-content-center gap-1"
    style="background-color: #2333AD; color: white; border: 1px solid white; border-radius: 6px; width: 45px; height: 40px;"
  >
    <i class="fas fa-mobile-alt"></i>
    <i class="fas fa-sign-in-alt"></i>
  </div>
</div>


        </div>
        <ul class="navbar-nav justify-content-end">
          <li v-if="loggedIn" class="nav-item d-flex align-items-center">
            <a id="dropdownProfileMenu" href="#" style="display: contents;"
              :class="`nav-link ${showProfileDropdown ? 'show' : ''}`" data-bs-toggle="dropdown" aria-expanded="false"
              @click="showProfileDropdown = !showProfileDropdown">
              <span class="avatar avatar-sm rounded-circle">
                <img :src="profileImage" class="h-100 profile-image">
              </span>
              <span v-if="isRTL" class="d-sm-inline d-none text-white p-2">{{ getNameNavbar }}</span>
              <span v-else class="d-sm-inline d-none text-white p-2">{{ getNameNavbar }}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end shadow position-absolute" style="margin-top: 0rem !important;"
              :class="showProfileDropdown ? 'show' : ''" aria-labelledby="dropdownProfileMenu">
              <div class="border-radius-md" style="padding: 0.3rem 1rem;">
                <small>
                  Welcome
                </small>
              </div>
              <router-link :to="{ name: 'User Profile' }">
                <li>
                  <a class="dropdown-item border-radius-md" href="javascript:;">
                    <div>
                      <i class="ni ni-circle-08"></i>
                      <span class="ms-2">My Profile</span>
                    </div>
                  </a>
                </li>
              </router-link>

              <!-- ✅ QR Code Login option -->
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;" @click="openQrModal">
                  <div>
                    <i class="fas fa-qrcode"></i>
                    <span class="ms-2">Mobile QR Login</span>
                  </div>
                </a>
              </li>

              <hr class="m-2">
              <li>
                <a class="dropdown-item border-radius-md" href="#" @click.prevent="handleLogout">
                  <div>
                    <i class="ni ni-user-run"></i>
                    <span class="ms-2">Logout</span>
                  </div>
                </a>
              </li>

            </ul>
          </li>
        </ul>
      </div>
    </div>

<!-- QR Code Modal -->
<div v-if="showQrModal" class="modal-backdrop d-flex align-items-center justify-content-center">
  <div class="modal-box bg-white rounded shadow-lg p-4 position-relative" style="max-width: 950px; width: 100%;">
    
    <!-- Close Button -->
    <button
      class="position-absolute top-0 end-0 m-3 fs-3 fw-bold border-0 bg-transparent"
      aria-label="Close"
      @click="showQrModal = false"
    >
      &times;
    </button>

    <!-- Header -->
    <h4 class="text-center text-primary fw-bold mb-1">Login with our new iPhone App</h4>
    <p class="text-center text-muted mb-4" style="font-size: 1.05rem;">
      Open your camera app and scan the QR below to log in instantly.
    </p>

    <!-- Content Layout -->
    <div class="d-flex justify-content-between align-items-start flex-wrap">

      
      
      <!-- QR Code + App Info -->
      <div class="text-center flex-fill me-3 d-flex flex-column align-items-center" style="min-width: 250px; padding-top: 55px;">
            <!-- Two‐Step Instructions -->
    <div class="px-3 mb-4">
      <ol class="mb-0" style="text-align: left; font-size: 1rem; max-width: 600px; margin: 0 auto 1rem;">
        <li>Scan the QR code with your camera app to install the app.</li>
        <li>Then you can scan the QR code again to automatically log in.</li>
      </ol>
    </div>

        <img :src="qrImage" alt="QR Code" class="img-fluid border rounded p-2 mb-2" style="max-width: 240px;" />
                <p
          class="text-center fw-bold text-dark mb-2"
          style="font-size: 1.25rem; cursor: pointer;"
          @click="countdown === 0 && openQrModal()"
        >
          <template v-if="countdown > 0">
            Expires in {{ Math.floor(countdown / 60) }}:{{ (countdown % 60).toString().padStart(2, '0') }}
          </template>
          <template v-else>
            <span class="text-danger">Code expired — <u>click to refresh</u></span>
          </template>
        </p>
      </div>

      <!-- Divider for spacing on small screens -->
      <div class="d-block d-md-none my-3 w-100"></div>

      <!-- App Screenshot + Arrows -->
      <div class="text-center flex-fill ms-3" style="min-width: 250px;">
        <img
          :src="appScreenshots[currentScreenshotIndex]"
          alt="App screenshot"
          class="img-fluid rounded mb-3"
          style="max-height: 455px;"
        />
        <div class="d-flex justify-content-center align-items-center gap-2 mb-2">
          <button
            class="btn btn-outline-secondary btn-sm px-3"
            :disabled="currentScreenshotIndex === 0"
            @click="currentScreenshotIndex--"
          >
            ‹
          </button>
          <button
            class="btn btn-outline-secondary btn-sm px-3"
            :disabled="currentScreenshotIndex === appScreenshots.length - 1"
            @click="currentScreenshotIndex++"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  </div>
</div>






    <div v-if="showSpinner" class="spinner-overlay">
      <div class="spinner"></div>
    </div>
    <video-tutorial-modal
        ref="videoModal"
        :is-open="isVideoModalOpen"
        :tutorials="tutorials"
        @close="closeVideoModal"
      />
  </nav>
  <notification-manager />
</template>


<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapState } from "vuex";
import placeholder from "../../assets/img/placeholder.jpg";
import showSwal from "../../mixins/showSwal.js";
import eventBus from "@/services/event-bus.service.js";
import { isPublicAuthPath } from "@/utils/public-auth-routes";
import axios from "axios";
import VideoTutorialModal from "../../components/VideoTutorialModal.vue";
import NotificationManager from "@/components/NotificationManager.vue";
import AuthService from "@/services/auth.service";
import { clearSsoHandoff } from "@/utils/sso-entry";
import { getAccessToken } from "@/services/token.service";

export default {
  name: "Navbar",
  components: {
    Breadcrumbs,
    VideoTutorialModal,
    NotificationManager
  },
  mixins: [showSwal],
  data() {
    return {
      key: 0,
      isVideoModalOpen: false, // Controls the visibility of the video modal
      showQrModal: false,
      qrImage: null,
      currentScreenshotIndex: 0,
      countdown: 120,
      countdownInterval: null,
      appScreenshots: [
        '/app_screenshot.png',
        '/app_screenshot_2.png'
      ],
      tutorials: [
      {
        title: "Dashboard: Overview",
        //url: `${process.env.VUE_APP_BASE_URL}/tutorials/1.mp4`,
        url: "http://protego-staging-assets.s3.us-west-1.amazonaws.com/tutorials/overview.mp4",
        route: "/dashboard/home",
      },
      {
        title: "9 Bullets: Understanding IQ & EQ",
        //url: `${process.env.VUE_APP_BASE_URL}/tutorials/1.mp4`,
        url: "http://protego-staging-assets.s3.us-west-1.amazonaws.com/tutorials/iq-eq.mp4",
        route: "/account",
      },
      {
        title: "Proposals: Downloading the Savings & Gap Reports",
        //url: `${process.env.VUE_APP_BASE_URL}/tutorials/1.mp4`,
        url: "http://protego-staging-assets.s3.us-west-1.amazonaws.com/tutorials/saving-report.mp4",
        route: null,
      },
      {
        title: "AMS360 Setup",
        url: "http://protego-staging-assets.s3.us-west-1.amazonaws.com/tutorials/ams360-setup.mp4",
        route: "/agency/integrations",
      },
      /*
  { title: "Getting Started", url: "https://file-examples.com/storage/fe0be45d9167742929e1545/2017/04/file_example_MP4_1920_18MG.mp4", route: "/manage" },
  { title: "Navigating the Dashboard", url: "https://download.samplelib.com/mp4/sample-15s.mp4", route: "/dashboard/home" },
  { title: "Creating a New Project", url: "https://example.com/videos/creating-new-project.mp4", route: "/projects" },
  { title: "Managing Users and Permissions", url: "https://example.com/videos/managing-users.mp4", route: "/users" },
  { title: "Generating Reports", url: "https://example.com/videos/generating-reports.mp4", route: "/reports" },
  { title: "Customizing Settings", url: "https://example.com/videos/customizing-settings.mp4", route: "/settings" },
  { title: "Advanced Features", url: "https://example.com/videos/advanced-features.mp4", route: "/advanced" },
  { title: "Best Practices", url: "https://example.com/videos/best-practices.mp4", route: "/best-practices" },
  { title: "Troubleshooting Common Issues", url: "https://example.com/videos/troubleshooting.mp4", route: "/troubleshooting" },*/
],

      showMenu: false,
      showProfileDropdown: false,
      showSpinner: false,
      profileImage: placeholder, // Default to placeholder initially
      headerTitle: "Default Title", // Initial default title
      showHeaderTitle: false, // Initially hidden
      showingDaysToClose: false, // Initially hidden
      showSearchHeader: false,
      daysToClose: 0,
      searchQuery: "",
      objects: [
        { name: "Alice", id: 1 },
        { name: "Bob", id: 2 },
        { name: "Charlie", id: 3 },
        { name: "Diana", id: 4 },
        { name: "Eve", id: 5 },
        { name: "Frank", id: 6 },
        { name: "Grace", id: 7 },
      ],
      filteredResults: [],
    };
  },
  computed: {
    hasTutorialForCurrentRoute() {
      const currentRoute = this.$route.path;
      const normalizedRoute = this.normalizeRoute(currentRoute);
      return this.tutorials.some((tutorial) => tutorial.route === normalizedRoute);
    },
    ...mapState(["isRTL", "isNavFixed", "darkMode"]),
    currentRouteName() {
      return this.$route.name;
    },
    currentDirectory() {
      let dir = this.$route.path.split("/")[1];
      return dir.charAt(0).toUpperCase() + dir.slice(1);
    },
    loggedIn() {
      return this.$store.getters["auth/isAuthenticated"];
    },
    getNameNavbar() {
      return this.$store.getters["profile/me"]?.name;
    },
  },
  async created() {
    const onPublicAuthPage = isPublicAuthPath(this.$route?.path || "");
    if (this.loggedIn && !onPublicAuthPage && getAccessToken()) {
      await this.fetchProfileImage();
    }
    eventBus.on("updateHeaderTitle", this.updateHeaderTitle);
    eventBus.on("toggleHeaderVisibility", this.toggleHeaderVisibility);
    eventBus.on("toggleHeaderSearch", this.toggleHeaderSearch);
    eventBus.on("updateDaysToClose", this.updateDaysToClose);
    eventBus.on("toggleDaysToClose", this.toggleDaysToClose);
    eventBus.on("updateProposalsList", this.updateProposals);
  },
  beforeUnmount() {
    eventBus.off("updateHeaderTitle", this.updateHeaderTitle);
    eventBus.off("toggleHeaderVisibility", this.toggleHeaderVisibility);
    eventBus.off("toggleHeaderSearch", this.toggleHeaderSearch);
    eventBus.off("updateDaysToClose", this.updateDaysToClose);
    eventBus.off("toggleDaysToClose", this.toggleDaysToClose);
    eventBus.off("updateProposalsList", this.updateProposals);
  },

  methods: {

    toggleSidenav() {
      this.$store.commit("navbarMinimize");
    },

    async openQrModal() {
  this.showQrModal = true;
  this.qrImage = null;
  this.countdown = 120;

  if (this.countdownInterval) {
    clearInterval(this.countdownInterval);
  }

  this.countdownInterval = setInterval(() => {
    if (this.countdown > 0) {
      this.countdown--;
    } else {
      clearInterval(this.countdownInterval);
    }
  }, 1000);

  try {
    const token = getAccessToken();

    const response = await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/generate-qr`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    this.qrImage = response.data.image;
  } catch (error) {
    console.error("Error fetching QR code:", error);
    this.qrImage = null;
  }
},

    normalizeRoute(route) {
    // Remove IDs (numbers) from the route using a regular expression
    return route.replace(/\/\d+/g, '');
  },
          
    filterResults() {
      console.log("FILTERING");
      // Filter based on the search query and limit results to 5
      if (this.searchQuery.trim().length > 0) {
        this.filteredResults = this.objects
          .filter((obj) => obj.client_name.toLowerCase().includes(this.searchQuery.toLowerCase()))
          .slice(0, 5); // Limit to max 5 results
      } else {
        this.filteredResults = [];
      }
      console.log("Filtered Results : ",this.filteredResults);
    },
    playAction() {
    const currentRoute = this.$route.path; // Get the current route
    console.log(currentRoute);
    this.isVideoModalOpen = true;
    this.$refs.videoModal.updateCurrentTutorial(currentRoute); // Update the modal's current tutorial
  },
    closeVideoModal() {
      // Close the video tutorial modal
      this.isVideoModalOpen = false;
    },
    selectResult(result) {
      // Handle selection from the dropdown
      console.log("Selected:", result);
      //this.searchQuery = result.client_name;
      this.searchQuery = '';
      this.filteredResults = []; // Clear dropdown after selection
      // Navigate to the /manage/:accountId route
      this.$router.push({ 
        path: `/manage/${result.id}` 
      });
    },
    updateHeaderTitle(newTitle) {
      this.headerTitle = newTitle;
    },

    updateProposals(propsoals) {
      this.objects = propsoals;
    },
    toggleHeaderSearch(show) {
      console.log("TOGGLING SEARCH HEADER VISIBILITY");
      this.showSearchHeader = show;
    },
    toggleHeaderVisibility(show) {
      console.log("TOGGLING HEADER VISIBILITY");
      this.showHeaderTitle = show;
      //this.showSearchHeader = show;

      
    },
    toggleDaysToClose(show) {
      console.log("TOGGLING DAYS TO CLOSE");
      this.showingDaysToClose = show;
    },
    updateDaysToClose(days) {
      this.daysToClose = days;
    },
    async fetchProfileImage() {
      try {
        const token = getAccessToken();

        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/profile/image`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            responseType: "blob",
          }
        );

        // Only set the profile image if the response contains a valid blob.
        if (response.data.size > 0) {
          const imageUrl = URL.createObjectURL(response.data);
          this.profileImage = imageUrl;
        } else {
          this.profileImage = placeholder; // Fallback to placeholder if no valid image
        }
      } catch (error) {
        console.error("Error fetching profile image:", error);
        this.profileImage = placeholder; // Fallback to placeholder in case of an error
      }
    },
    async handleLogout() {
      try {
        clearSsoHandoff();
        await AuthService.logout();
      } finally {
        // Navigate to the Login page
        this.$store.commit('agencyStyle/CLEAR_AGENCY_STYLE');
        this.$store.commit('auth/isAuthenticated', false);
        await this.$router.push({ name: "Login" });
      }
    },
    goBack() {
      // Go back to the previous page
      window.history.back();
    },
    refreshPage() {
      this.showSpinner = true;
      eventBus.emit('refreshComponent');
      setTimeout(() => {
        this.showSpinner = false;
        window.location.reload();
      }, 300);
    },
  },
};
</script>

<style scoped>

.modal-backdrop {
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}

.modal-box {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  padding: 2rem;
  position: relative;
  max-width: 400px;
  width: 90%;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 14px;
  font-size: 24px;
  border: none;
  background: none;
  cursor: pointer;
}

.qr-image {
  max-width: 100%;
  width: 60%;
  height: auto;
}

.back-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 15px;
}

.back-button .nav-link {
  font-size: 18px;
  color: white;
  padding: 0;
}

.back-button .nav-link i {
  color: white;
}

.refresh-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 15px;
}

.refresh-button .nav-link {
  font-size: 18px;
  color: white;
  padding: 0;
}

.refresh-button .nav-link i {
  color: white;
}

.navbar-menu-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.12);
  color: white;
}

.navbar-menu-toggle:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35);
}

.navbar-menu-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: white;
}

.play-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 15px;
}

.play-button .nav-link {
  font-size: 18px;
  color: white;
  padding: 0;
}

.play-button .nav-link i {
  color: white;
}


.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: white;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  top: 125%; /* Position below the button */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}



.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.header-title {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.header-title h3 {
  margin: 0;
  font-size: 24px;
  color: white;
}

/* Optional styles for dropdown interactivity */
.dropdown-menu li:hover {
  background-color: #f0f0f0;
}
</style>
